import PropertySearch from './PropertySearch';

export default PropertySearch;
